import React from "react";
import { Container, Nav, Navbar } from "react-bootstrap";

const MainHeader: React.FC = () => {
    return (
        <Navbar expand="lg" sticky="top" className="bg-body-tertiary top-menu">
            <Container>
                <Navbar.Brand href="#home">
                    <img
                        src="/images/riudicc_logo.png"
                        width="130"
                        height="40"
                        className="d-inline-block align-top"
                        alt="React Bootstrap logo"
                        id="home"
                    />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav" className="mx-end">
                    <Nav className="ms-auto">
                        <Nav.Link href="#nosotros" className="pe-5"><b>NOSOTROS</b></Nav.Link>
                        <Nav.Link href="#socios" className="pe-5"><b>SOCIOS</b></Nav.Link>
                        <Nav.Link href="#contacto"><b>CONTACTO</b></Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}

export default MainHeader;